/**
 * 获取下拉框数据
 */
import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  getPlatformSelect: params => axios({ baseURL, url: '/api/store/allPlatform', params }), // 平台下拉框数据
  // getStoreSelect: (platformCode, userId) => axios({ baseURL, url: `/api/store/${platformCode}/allStore/${userId}` }), // 店铺下拉框数据
  getStoreSelect: data => axios({ baseURL, url: `/api/store/allStore`, method: 'post', data }), // 店铺下拉框数据
  getCurrencySelect: params => axios({ baseURL, url: '/api/system/allCurrency', params }), // 币种下拉框数据

  getSelectList: params => axios({ baseURL, url: '/api/system/open/dropDownInfo', params }), // 获取下拉框列表；type 下拉语种传：1，退换条款传：2，国家信息传：3， 产品规则 刊登可勾选配置项：15

  getPublications: params => axios({ baseURL, url: `/api/listings/publications`, params }) // 获取销售渠道列表
}
